import React from 'react';
import { motion } from 'framer-motion';
const pairs = [{
  label: 'Bathroom Reset',
  before: 'https://cdn.magicpatterns.com/uploads/gp1CcJjiYxsiqT7YFxUtTY/ChatGPT_Image_Jun_11,_2026,_05_56_15_PM.png',
  after: 'https://cdn.magicpatterns.com/uploads/hzZU2KDyepiwJMMSLoYMMe/ChatGPT_Image_Jun_11,_2026,_05_56_23_PM.png'
}, {
  label: 'Post-Construction Reset',
  before: 'https://cdn.magicpatterns.com/uploads/oZUJcNfYV8jipx6C3nWJu2/ChatGPT_Image_Jun_11,_2026,_05_55_53_PM.png',
  after: 'https://cdn.magicpatterns.com/uploads/o7XUXw52yttqJ7oYxU1XH4/ChatGPT_Image_Jun_11,_2026,_05_56_03_PM.png'
}, {
  label: 'Luxury Interior Reset',
  before: 'https://cdn.magicpatterns.com/uploads/qKzKrTLKfvDD2tWZChsJLo/ChatGPT_Image_Jun_11,_2026,_06_33_48_PM_(1).png',
  after: 'https://cdn.magicpatterns.com/uploads/x9mMAvug2e95S8Wut1vUPz/ChatGPT_Image_Jun_11,_2026,_06_33_48_PM_(2).png'
}];
export function BeforeAfter() {
  return <section className="py-32 bg-paper" data-id="element-12" data-mp="x40vycg1uq6i">
      <div className="container mx-auto px-8 lg:px-12" data-id="element-13" data-mp="x2z9lbtl2h9h">
        <div className="mb-20 text-center" data-id="element-14" data-mp="t3i0m8ey71zk">
          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-15" data-mp="t2fesewhfpqi">
            <div className="w-8 h-[1px] bg-lime" data-id="element-16" data-mp="171or33hkhzp7"></div>
            <span className="text-ink/50 font-body text-xs uppercase tracking-[0.3em]" data-id="element-17" data-mp="170dlcy4kahvg">
              Transformations
            </span>
            <div className="w-8 h-[1px] bg-lime" data-id="element-18" data-mp="edav0ta1hdga"></div>
          </div>
          <h2 className="text-4xl md:text-5xl text-ink font-light" data-id="element-19" data-mp="9ezlkjnnp4yl">
            See the <span className="font-medium" data-id="element-20" data-mp="9cwkn4kytrf3">Reset.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 max-w-7xl mx-auto" data-id="element-21" data-mp="o5gltzok1otw">
          {pairs.map((pair, index) => <motion.div key={pair.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2,
          ease: 'easeOut'
        }} className="group" data-id="element-22" data-mp="jbca734cgsmh" data-mpi={index}>
              <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-23" data-mp="24i4k1a072xo1">
                {/* BEFORE */}
                <div className="relative aspect-[4/5] overflow-hidden bg-graphite" data-id="element-24" data-mp="24jyv7wlnzbex">
                  <img src={pair.before} alt={`${pair.label} — before`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-25" data-mp="17tybic05jl4h" />
                  <div className="absolute bottom-6 left-6 bg-paper/90 backdrop-blur-sm text-ink px-4 py-2 text-[10px] uppercase tracking-[0.2em]" data-id="element-26" data-mp="1lrwnjar035gt">
                    Before
                  </div>
                </div>

                {/* AFTER */}
                <div className="relative aspect-[4/5] overflow-hidden bg-concrete/20" data-id="element-27" data-mp="2x8wea1xp9c8q">
                  <img src={pair.after} alt={`${pair.label} — after`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-28" data-mp="379yo9d3b420c" />
                  <div className="absolute bottom-6 right-6 bg-ink/90 backdrop-blur-sm text-lime px-4 py-2 text-[10px] uppercase tracking-[0.2em]" data-id="element-29" data-mp="2tjlklmxg79gt">
                    After
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between border-t border-concrete/50 pt-4" data-id="element-30" data-mp="2jke6uymsxct6">
                <p className="text-ink font-medium tracking-wide text-sm" data-id="element-31" data-mp="2emuih5we3jni">
                  {pair.label}
                </p>
                <div className="w-1.5 h-1.5 rounded-full bg-lime" data-id="element-32" data-mp="2amkcht8lkt8n"></div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}